const PROGRAM_SUMMARY = 'Program Summary'
const EVENTS_SUMMARY = 'Events Summary'
const EVENT_TELEMETRY_REPORT = 'Event Telemetry Report'
const PRODUCTION_FORECASTING = 'Production Forecasting'
const LOAD_BUILD_FORECASTING = 'Load Build Forecasting'
const LOAD_REDUCTION_FORECASTING = 'Load Reduction Forecasting'
const ENERGY_AVAILABLE_FORECASTING = 'Energy Available Forecasting'
const SYSTEM_DETAILS_REPORT = 'System Details Report'
const EVENT_PARTICIPATION_HISTORY = 'Event Participation History'
const OUTRAGE_REPORT = 'Grid Outage Report'
const USER_SUMMARY = 'User Summary'
const NOT_SELECTED = 'Select a report from the left pane'
const NOT_SELECTED_MD = 'Select a report from the above pane'

export {
  PROGRAM_SUMMARY,
  EVENTS_SUMMARY,
  EVENT_TELEMETRY_REPORT,
  PRODUCTION_FORECASTING,
  LOAD_BUILD_FORECASTING,
  LOAD_REDUCTION_FORECASTING,
  ENERGY_AVAILABLE_FORECASTING,
  SYSTEM_DETAILS_REPORT,
  EVENT_PARTICIPATION_HISTORY,
  OUTRAGE_REPORT,
  USER_SUMMARY,
  NOT_SELECTED,
  NOT_SELECTED_MD
}



